import dayjs from 'dayjs'
import * as storageUtils from '@g/utils/storageUtils'
import tpttCart from './tpttCart'
import tpTbkorder from './tpTbkorder'
import tpttShake from './tpttShake'
import tpttTrade from './tpttTrade'
import tpTariff from './tpTariff'
import tpttCanMailSea from './tpttCanMailSea'
import tpttCanMail from './tpttCanMail'
import tpttItem from './tpttItem'
import tpTradeSeller from './tpTradeSeller'

const state = {
  clickedItemids: storageUtils.get('tpspClickedItemids') || [],
}

const getters = {
}

const mutations = {
  setClickedItemids: (state, v) => {
    state.clickedItemids = v
    storageUtils.set('tpspClickedItemids', v, 30)
  },
}

const actions = {
  pushClickedItemids ({ state, commit }, params) {
    const clickedItemids = [...state.clickedItemids]
    const existItem = clickedItemids.find(item => item.tradeid === params.tradeid)
    const expire = dayjs().add(30, 'minute').valueOf()
    if (existItem) {
      existItem.expire = expire
    } else {
      clickedItemids.push({
        itemid: params.itemid,
        tradeid: params.tradeid,
        expire,
      })
    }
    commit('setClickedItemids', clickedItemids)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    tpttCart,
    tpTbkorder,
    tpttShake,
    tpttTrade,
    tpTariff,
    tpttCanMailSea,
    tpttCanMail,
    tpttItem,
    tpTradeSeller,
  }
}
